import { IFormDefinition } from "@entaconsulting/form";

type Options =
  | {
      isTableElement: boolean;
    }
  | undefined;

const generateNewFieldName = (
  formDefinition: IFormDefinition,
  options: Options = { isTableElement: false }
) => {
  const { isTableElement } = options;

  const prefixName = isTableElement ? "Table" : "Field";

  let numberOfNewFields: number = 1;
  let newFieldName: string = `${prefixName}${numberOfNewFields}`;
  let exists: boolean = !!formDefinition.schema[newFieldName];

  while (exists) {
    newFieldName = `${prefixName}${numberOfNewFields++}`;
    exists = !!formDefinition.schema[newFieldName];
  }

  return newFieldName;
};

export default generateNewFieldName;
